module.exports = __webpack_public_path__ + "static/media/android.14ed07e6.svg";